import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  InputGroup,
  InputRightAddon,
  Flex,
  Icon,
  Text,
  TableContainer,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const notifData = [
  {
    user: "Mayank",
    subject: "Deposit Successful",
    message: "Your deposit of ₹100 has been approved.",
    time: "2025-04-07 07:00 PM",
  },
  {
    user: "All Users",
    subject: "Bonus Update",
    message: "A new referral bonus is available!",
    time: "2025-04-06 12:00 PM",
  },
];

const NotificationHistory = () => {
  const SIDEBAR_WIDTH = "240px";
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="gray.50"
        minH="100vh"
        mt="64px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        <Flex
          mb={8}
          justify="space-between"
          align={{ base: "stretch", md: "center" }}
          direction={{ base: "column", md: "row" }}
          gap={3}
        >
          <Text fontSize="2xl" fontWeight="semibold" color="#1a202c">
            Notification History
          </Text>
          <InputGroup maxW="300px" size="md">
            <Input
              bg="white"
              placeholder="Search..."
              borderRight="none"
              _focus={{ borderColor: "#4f46e5", boxShadow: "none" }}
            />
            <InputRightAddon bg="#4f46e5" cursor="pointer">
              <Icon as={SearchIcon} color="white" />
            </InputRightAddon>
          </InputGroup>
        </Flex>

        {isMobile ? (
          <VStack spacing={4} align="stretch">
            {notifData.map((d, i) => (
              <Box
                key={i}
                bg="white"
                p={4}
                borderRadius="lg"
                boxShadow="sm"
                border="1px solid #e2e8f0"
              >
                <Flex justify="space-between" mb={2}>
                  <Text fontWeight="600" fontSize="sm">
                    User
                  </Text>
                  <Text fontSize="sm">{d.user}</Text>
                </Flex>
                <Flex justify="space-between" mb={2}>
                  <Text fontWeight="600" fontSize="sm">
                    Subject
                  </Text>
                  <Text fontSize="sm" fontWeight="medium">
                    {d.subject}
                  </Text>
                </Flex>
                <Box mb={2}>
                  <Text fontWeight="600" fontSize="sm" mb={1}>
                    Message
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    {d.message}
                  </Text>
                </Box>
                <Flex
                  justify="space-between"
                  pt={2}
                  borderTop="1px solid #f0f2f5"
                >
                  <Text fontWeight="600" fontSize="sm">
                    Sent At
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    {d.time}
                  </Text>
                </Flex>
              </Box>
            ))}
          </VStack>
        ) : (
          <Box
            bg="white"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="sm"
            border="1px solid #e2e8f0"
          >
            <TableContainer>
              <Table variant="simple">
                <Thead bg="#4f46e5">
                  <Tr h="50px">
                    <Th
                      color="white"
                      textTransform="none"
                      borderTopLeftRadius="lg"
                    >
                      User
                    </Th>
                    <Th color="white" textTransform="none">
                      Subject
                    </Th>
                    <Th color="white" textTransform="none">
                      Message
                    </Th>
                    <Th
                      color="white"
                      textTransform="none"
                      textAlign="right"
                      borderTopRightRadius="lg"
                    >
                      Sent At
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {notifData.map((d, i) => (
                    <Tr key={i} _hover={{ bg: "gray.50" }}>
                      <Td fontWeight="600" fontSize="sm">
                        {d.user}
                      </Td>
                      <Td fontSize="sm" fontWeight="medium">
                        {d.subject}
                      </Td>
                      <Td fontSize="sm" maxW="400px" isTruncated>
                        {d.message}
                      </Td>
                      <Td fontSize="sm" color="gray.500" textAlign="right">
                        {d.time}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </Box>
    </>
  );
};

export default NotificationHistory;
